{
	"$schema": "https://schemas.wp.org/trunk/block.json",
	"apiVersion": 3,
	"name": "bytesco/product-grid",
	"title": "Product Grid",
	"icon": "cloud",
	"description": "A set of grids",
	"keywords": ["meta"],
	"version": "0.0.1",
	"textdomain": "bytesco",
	"script": "file:build/entry.js",
	"style": "file:build/entry.css",
	"render": "file:render.php"
}